import React, { memo, ReactElement } from 'react';
import { StyledDataForm } from 'adapter/in/common/form/data/DataForm/style';
import withLoading from 'adapter/in/common/hoc/withLoading';
import { Cell, Row } from '@dexma/ui-components';
import i18n from 'asset/translation';

export type DataFormType = {
    data: ReactElement | ReactElement[];
    featurePresetText?: string;
};

const DataForm = memo((props: DataFormType) => {
    const { data: fields, featurePresetText } = props;

    return (
        <StyledDataForm data-testid='data-form'>
            {featurePresetText && (
                <>
                    <Row className='feature-preset-label-block'>
                        <Cell className='widget-type-block'>
                            <span>{i18n.t('widgets.widgetMenu.featurePresetTitle')}</span>
                        </Cell>
                    </Row>

                    <Row className='feature-preset-block'>
                        <Cell>
                            <span className='feature-preset'>{featurePresetText}</span>
                        </Cell>
                    </Row>
                </>
            )}
            {fields}
        </StyledDataForm>
    );
});

export default withLoading(DataForm);
